import { render, staticRenderFns } from "./ObatUpload.vue?vue&type=template&id=0d3c6138&"
import script from "./ObatUpload.vue?vue&type=script&lang=js&"
export * from "./ObatUpload.vue?vue&type=script&lang=js&"
import style0 from "./ObatUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports